/**
 * @flow
 * @author: Vamsi Tallam
 * */

import React, { Component } from 'react'

import CloseIconWhite from '../../Icons/CloseIconWhite'

import ApplyForFranchiseAgentForm from './ApplyForFranchiseAgentForm'
import {
  ModalBodyContainer,
  ModalWrapper,
  CloseIconWrapper
} from './styledComponents'

class EnquireNowModal extends Component {
  render() {
    const { formData, glsLoaded, closeModal } = this.props
    return (
      <ModalBodyContainer>
        <ModalWrapper>
          <CloseIconWrapper onClick={() => closeModal()}>
            <CloseIconWhite width={10} height={10} fill="#fff" />
          </CloseIconWrapper>
          <ApplyForFranchiseAgentForm
            formData={formData}
            glsLoaded={glsLoaded}
            closeModal={closeModal}
          />
        </ModalWrapper>
      </ModalBodyContainer>
    )
  }
}

export default EnquireNowModal



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/EnquireNowModal/index.js